import { Bucket } from '../types/Posts'

export function bucketAdapter(bucket: any): Bucket {
  const now = new Date().getTime()
  let activeTo = bucket.activeTo
  if (activeTo) {
    // end of day
    activeTo = new Date(activeTo).setHours(23, 59, 59, 999) // eslint-disable-line no-magic-numbers
  }

  return {
    id: bucket.id.toString(),
    name: bucket.name.trim(),
    color: bucket.color.split(',')[0],
    ppids: bucket.ppPageIds,
    isPublic: bucket.isPubic,
    isActive: bucket.isActive,
    order: bucket.order || 0,
    pages: bucket.pages.map((p: any) => ({
      plannedPostsCount: p.plannedPostsCount,
      ppid: p.ppPageId.toString(),
      slotsCount: p.activeSlotsCount
    })),
    postsCount: bucket.pages.reduce((count: number, page: any) => {
      count += page.plannedPostsCount
      return count
    }, 0),
    activeFrom: bucket.activeFrom,
    activeTo: bucket.activeTo,
    isExpired: activeTo ? new Date(activeTo).getTime() < now : false,
    description: bucket.description,
    groupId: bucket.groupId?.toString() || null
  }
}
